import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'button-request-details',
  templateUrl: './button-request-details.component.html',
  styleUrls: ['./button-request-details.component.scss']
})
export class ButtonRequestDetail implements OnInit {
  @Output() eventClick = new EventEmitter<any>();

  constructor() { 
    //This is intentional.
  }

  ngOnInit(): void {
    //This is intentional.
  }

  viewDetails() {
    this.eventClick.emit();
  }
}
